module.exports = __webpack_public_path__ + "static/media/backgroundNHL_Dark.ae77b114.svg";